module.exports = __webpack_public_path__ + "static/waterfall_light-9a269454f224d412e824a6c117cf9b81.gif";